import {Button, Card, Space, Typography,} from "antd";
import {Link} from "react-router-dom";
import LockMap from "@/components/map/LockMap";
import React, {useEffect, useState} from "react";
import RenderIf from "@/components/render-if";

const {Title, Text} = Typography;

export default function ShowMyLessonAddress({data}) {

    const [classrooms, setClassrooms] = useState({})

    useEffect(() => {
        let c = {}
        data?.map((item) => {
            if (!c[item?.classroom?.id]) {
                c[item?.classroom?.id] = item;
            }
        })
        setClassrooms(c)

    }, [data]);

    const cls = Object.keys(classrooms).map((key) => classrooms[key]);


    return (
        <RenderIf condition={cls?.length > 0}>
            {cls?.map((item) => (
                <RenderIf condition={item?.classroom?.latitude && item?.classroom?.longitude}>
                    <Card
                        className="my-2 overflow-hidden rounded-[20px] border-0 bg-gradient-to-br from-[#1677ff] to-[#69b1ff] "

                    >
                        <div className="flex flex-wrap items-center justify-between gap-2">
                            <div className="min-w-[280px] flex-1">
                                <Space direction="vertical" size={8}>
                                    <Title level={4} className="!m-0 !text-white">

                                        <span className={'mx-1 font-bold'}>{item?.classroom?.title}</span>
                                        <div>

                                            <div className="flex flex-wrap gap-1">
                                                {/*<div>{item?.street}</div>*/}
                                                <div>{item?.classroom?.address}</div>
                                            </div>

                                            <Link
                                                to={`https://nshn.ir/?lat=${item?.classroom?.latitude}&lng=${item?.classroom?.longitude}`}
                                                target={`_blank`}
                                            >
                                                <Button type="primary" size={'small'}>
                                                    مسیریابی با نشان
                                                </Button>
                                            </Link>
                                        </div>
                                    </Title>


                                </Space>
                            </div>

                            <div
                                className="h-[150px] w-[150px] overflow-hidden rounded-2xl shadow-[0_10px_30px_rgba(0,0,0,0.15)]">
                                <div className={'w-[150px] h-[150px]'}>

                                    <LockMap point={item?.classroom} zoom={16}/>
                                </div>
                            </div>

                        </div>
                    </Card>
                </RenderIf>
            ))}

        </RenderIf>
    );
}
